export default __webpack_public_path__ + "static/media/1844.798bf6e3.png";